import React from "react";
import bannerImg from "../../assets/images/delivery.png";

export default function BannerSection() {
  return (
    <div className="flex justify-center bg-gradient-to-r from-white to-blue-100">
      <div className="bg-gradient-to-r from-white to-blue-100 md:w-9/12 w-11/12 md:h-[400px] h-auto rounded-xl p-8 flex md:flex-row flex-col justify-center text-black">
        <div className="md:w-1/2 w-full flex justify-center">
          <img src={bannerImg} alt="" className="md:h-[366px] h-[200px]" />
        </div>
        <div className="text-black md:w-1/2 w-full flex flex-col justify-center h-full mt-6 md:mt-0">
          <h2 className="font-semibold text-3xl md:text-4xl italic text-[#5c1a32]">
            Delivering excellence every step ahead
          </h2>
          <p className="md:mt-6 mt-4 tracking-wide text-base">
            We bring reliability and care to your doorstep—whether it's clean
            water, fresh laundry, or life-saving oxygen. Our team is committed
            to quality, efficiency, and service that puts your needs first.
          </p>
          <div className="flex md:flex-row flex-col justify-start md:gap-10 gap-4 md:mt-12 mt-8">
            <div className="">
              <button className="bg-[#3d0000] text-white h-[40px] w-full px-6 rounded-lg md:text-normal text-sm">
                Get Started
              </button>
            </div>
            <div className="">
              <a href="mailto:support@sansarsadasya.com">
                <button className="bg-[#3d0000] text-white h-[40px] w-full px-6 rounded-lg md:text-normal text-sm">
                  Contact With Us
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
